import { EditBase, Form } from "ra-core";
import { Card, CardContent } from "@/components/ui/card";

import { FormToolbar } from "../layout/FormToolbar";
import { ActivityInputs } from "./ActivityInputs";

export const ActivityEdit = () => (
  <EditBase redirect="list">
    <div className="mt-2 flex max-w-2xl">
      <Form className="flex-1">
        <Card>
          <CardContent>
            <ActivityInputs />
            <FormToolbar />
          </CardContent>
        </Card>
      </Form>
    </div>
  </EditBase>
);
